import React from "react";
import { RouteComponentProps } from "react-router-dom";

import { App } from "../../App";
import { AuthSplash } from "../../components/AuthSplash";
import { Modal } from "../../components/Modal";

const Home: React.FC<RouteComponentProps> = () => (
  <AuthSplash>
    <Modal />

    <App />
  </AuthSplash>
);

export default Home;
